import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-5343">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-5344">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-5345">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-5346">
            <ArrowLeft className="w-4 h-4" data-id="element-5347" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-5348">NOIZA</div>
          <div className="w-20" data-id="element-5349" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-5350">
        <div className="mb-12" data-id="element-5351">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-5352">
            <FileText className="w-6 h-6 text-white/80" data-id="element-5353" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-5354">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-5355">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-5356">
          <section data-id="element-5357">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5358">
              <span className="text-[#006847]" data-id="element-5359">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5360">
              <p data-id="element-5361">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-5362">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5363">
                <li data-id="element-5364">Haber leído íntegramente este documento</li>
                <li data-id="element-5365">Comprender su contenido en su totalidad</li>
                <li data-id="element-5366">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-5367">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-5368">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5369">
              <span className="text-[#006847]" data-id="element-5370">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5371">
              <p data-id="element-5372">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5373">
                <li data-id="element-5374">Software como servicio (SaaS)</li>
                <li data-id="element-5375">Marketplace digital gastronómico</li>
                <li data-id="element-5376">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-5377">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5378">
                <li data-id="element-5379">Mostrar su menú digital</li>
                <li data-id="element-5380">Recibir pedidos de clientes</li>
                <li data-id="element-5381">Gestionar su operación interna</li>
                <li data-id="element-5382">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-5383">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-5384">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5385">
              <span className="text-[#006847]" data-id="element-5386">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5387">
              <p data-id="element-5388">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5389">
                <li data-id="element-5390">No es proveedor de alimentos</li>
                <li data-id="element-5391">No participa en la preparación de productos</li>
                <li data-id="element-5392">No manipula alimentos en ningún momento</li>
                <li data-id="element-5393">No realiza entregas ni logística</li>
                <li data-id="element-5394">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-5395">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-5396">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-5397">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5398">
              <span className="text-[#006847]" data-id="element-5399">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-5400">
              <p data-id="element-5401">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-5402">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5403">
                <li data-id="element-5404">El restaurante es el único responsable de su operación</li>
                <li data-id="element-5405">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-5406">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-5407">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5408">
                <li data-id="element-5409">Precios</li>
                <li data-id="element-5410">Menú</li>
                <li data-id="element-5411">Horarios</li>
                <li data-id="element-5412">Métodos de pago</li>
                <li data-id="element-5413">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5414">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5415">
              <span className="text-[#006847]" data-id="element-5416">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-5417">
              <div data-id="element-5418">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5419">
                  5.1. Alcance general
                </h3>
                <p data-id="element-5420">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-5421">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5422">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-5423">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5424">
                  <li data-id="element-5425">Calidad de los alimentos</li>
                  <li data-id="element-5426">Estado, frescura o preparación</li>
                  <li data-id="element-5427">Ingredientes utilizados</li>
                  <li data-id="element-5428">Contaminación cruzada</li>
                  <li data-id="element-5429">Problemas de higiene o salubridad</li>
                  <li data-id="element-5430">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5431">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-5432">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5433">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-5434">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5435">
                  <li data-id="element-5436">Retrasos en la entrega</li>
                  <li data-id="element-5437">Pérdida de pedidos</li>
                  <li data-id="element-5438">Entregas incompletas</li>
                  <li data-id="element-5439">Errores en dirección</li>
                  <li data-id="element-5440">Conducta de repartidores</li>
                  <li data-id="element-5441">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-5442">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5443">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-5444">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-5445">
                  <li data-id="element-5446">Recepción de pagos</li>
                  <li data-id="element-5447">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-5448">Manejo de efectivo</li>
                  <li data-id="element-5449">Confirmación de pagos</li>
                  <li data-id="element-5450">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-5451">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5452">
                  <li data-id="element-5453">Pagos no recibidos</li>
                  <li data-id="element-5454">Comprobantes falsos</li>
                  <li data-id="element-5455">Errores en montos</li>
                  <li data-id="element-5456">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-5457">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5458">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-5459">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5460">
                  <li data-id="element-5461">Reclamos de clientes</li>
                  <li data-id="element-5462">Reembolsos</li>
                  <li data-id="element-5463">Cancelaciones</li>
                  <li data-id="element-5464">Disputas</li>
                  <li data-id="element-5465">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5466">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-5467">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5468">
              <span className="text-[#006847]" data-id="element-5469">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-5470">
              <p data-id="element-5471">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5472">
                <li data-id="element-5473">Responsable</li>
                <li data-id="element-5474">Legal</li>
                <li data-id="element-5475">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-5476">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5477">
                <li data-id="element-5478">Publicar información falsa</li>
                <li data-id="element-5479">Manipular precios de forma engañosa</li>
                <li data-id="element-5480">Simular disponibilidad inexistente</li>
                <li data-id="element-5481">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5482">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5483">
              <span className="text-[#006847]" data-id="element-5484">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-5485">
              <p data-id="element-5486">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5487">
                <li data-id="element-5488">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-5489">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-5490">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5491">
                <li data-id="element-5492">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-5493">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-5494">
                    <li data-id="element-5495">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-5496">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-5497">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5498">
              <span className="text-[#006847]" data-id="element-5499">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-5500">
              <p data-id="element-5501">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5502">
                <li data-id="element-5503">Menú digital</li>
                <li data-id="element-5504">Gestión de pedidos</li>
                <li data-id="element-5505">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-5506">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5507">
                  <p className="font-medium text-white mb-2" data-id="element-5508">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5509">
                    <li data-id="element-5510">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5511">
                  <p className="font-medium text-white mb-2" data-id="element-5512">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5513">
                    <li data-id="element-5514">Propiedad del software</li>
                    <li data-id="element-5515">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-5516">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-5517">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5518">
              <span className="text-[#006847]" data-id="element-5519">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5520">
              <p data-id="element-5521">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5522">
                <li data-id="element-5523">Disponibilidad continua</li>
                <li data-id="element-5524">Funcionamiento sin interrupciones</li>
                <li data-id="element-5525">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-5526">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5527">
                <li data-id="element-5528">Fallas técnicas</li>
                <li data-id="element-5529">Actualizaciones</li>
                <li data-id="element-5530">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-5531">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-5532">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5533">
              <span className="text-[#006847]" data-id="element-5534">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-5535">
              <p data-id="element-5536">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5537">
                <li data-id="element-5538">No está garantizada permanentemente</li>
                <li data-id="element-5539">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-5540">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5541">
                <li data-id="element-5542">Destacar o no restaurantes</li>
                <li data-id="element-5543">Modificar posiciones</li>
                <li data-id="element-5544">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5545">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5546">
              <span className="text-[#006847]" data-id="element-5547">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-5548">
              <p data-id="element-5549">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5550">
                <li data-id="element-5551">Cumplir con los pagos acordados</li>
                <li data-id="element-5552">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-5553">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5554">
                <li data-id="element-5555">Suspender el servicio</li>
                <li data-id="element-5556">Limitar funcionalidades</li>
                <li data-id="element-5557">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5558">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5559">
              <span className="text-[#006847]" data-id="element-5560">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5561">
              <p data-id="element-5562">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5563">
                <li data-id="element-5564">Incumplimiento de términos</li>
                <li data-id="element-5565">Uso indebido</li>
                <li data-id="element-5566">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-5567">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-5568">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5569">
              <span className="text-[#006847]" data-id="element-5570">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-5571">
              <p data-id="element-5572">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-5573">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-5574">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5575">
              <span className="text-[#006847]" data-id="element-5576">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-5577">
              <p data-id="element-5578">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5579">
                <li data-id="element-5580">Pérdidas económicas</li>
                <li data-id="element-5581">Daños indirectos</li>
                <li data-id="element-5582">Lucro cesante</li>
                <li data-id="element-5583">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5584">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5585">
              <span className="text-[#006847]" data-id="element-5586">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-5587">
              <p data-id="element-5588">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-5589">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5590">
              <span className="text-[#006847]" data-id="element-5591">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-5592">
              <p className="font-medium" data-id="element-5593">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-5594">
                <li data-id="element-5595">Ha leído este documento completo</li>
                <li data-id="element-5596">Comprende su alcance</li>
                <li data-id="element-5597">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}